import {
  Avatar,
  Badge,
  Box,
  Button,
  Divider,
  Flex,
  HStack,
  Icon,
  Text,
  Tooltip,
} from '@chakra-ui/react';
import { MdEmail, MdCheckCircle } from 'react-icons/md';
import Card from 'components/card/Card';
import { useTranslation } from "i18n/TranslationProvider";

const OwnerInfoCard = ({ owner, onApprove, onReject, isLoading }) => {
  const { t } = useTranslation();
  const statusColor = {
    pending: 'yellow',
    approved: 'green',
    rejected: 'red',
    disabled: 'gray',
  }[owner.validationStatus || 'pending'];
  return (
    <Card p={5} borderWidth="1px" borderRadius="xl" shadow="md">
      <Flex align="center" justify="space-between" flexWrap="wrap">
        {/* Left Section */}
        <Flex align="center" gap={4}>
          <Avatar
            name={owner.displayName}
            bg="brand.500"
            color="white"
            size="lg"
          />
          <Box>
            <Flex align="center" gap={2}>
              <Text fontWeight="bold" fontSize="lg">
                {owner.displayName}
              </Text>
              <Badge colorScheme={statusColor} variant="subtle" px={2}>
                {t(owner.role)}
              </Badge>
              {owner.isEmailVerified && (
                <Tooltip label={t("Email verified")}>
                  <Icon as={MdCheckCircle} color="green.400" />
                </Tooltip>
              )}
            </Flex>
            <Flex align="center" gap={2}>
              <Icon as={MdEmail} color="gray.400" />
              <Text fontSize="sm" color="gray.500">
                {owner.email}
              </Text>
            </Flex>
          </Box>
        </Flex>

        {/* Right Section: Validation Status */}
        <Badge
          colorScheme={statusColor}
          px={3}
          py={1}
          borderRadius="full"
          fontSize="sm"
        >
          {t(`validationStatus_${owner.validationStatus || 'pending'}`).toUpperCase()}
        </Badge>
      </Flex>

      <Divider my={4} />

      {/* Metadata Section */}
      <HStack spacing={6} flexWrap="wrap">
        <Text fontSize="sm">
          <b>{t("Bookings")}:</b> {owner.createdBookingsCount || 0}
        </Text>
        <Text fontSize="sm">
          <b>{t("Trucks")}:</b> {owner.trucks?.length || 0}
        </Text>
        <Text fontSize="sm">
          <b>{t("Drivers")}:</b> {owner.drivers?.length || 0}
        </Text>
      </HStack>

      <Divider my={4} />

      {/* Action Buttons */}
      <Flex justify="flex-end" gap={3}>
        <Button variant="outline" colorScheme="blue" size="sm">
          {t("View profile")}
        </Button>
      </Flex>
    </Card>
  );
};

export default OwnerInfoCard;
